<template>
    <div class="crm-notes-activity">
        <div class="notes-activity-layout">
            <!-- LEFT: Internal Notes -->
            <b-card class="notes-card">
                <div class="card-header-row">
                    <span class="card-label">INTERNAL NOTES</span>
                    <b-button variant="link" class="link-add p-0" @click="addNote">Add</b-button>
                </div>
                <div class="notes-list">
                    <div
                        v-for="note in notes"
                        :key="note.id"
                        class="note-item"
                    >
                        <div class="note-content">{{ note.content }}</div>
                        <div class="note-footer">
                            <span class="note-meta">{{ note.author }} · {{ note.date }}</span>
                            <b-button variant="link" class="btn-delete-note p-0" @click="deleteNote(note)">
                                <i class="fa fa-trash-o"></i>
                            </b-button>
                        </div>
                    </div>
                </div>
            </b-card>

            <!-- RIGHT: Activity Timeline -->
            <b-card class="timeline-card">
                <div class="card-label mb-3">ACTIVITY TIMELINE</div>
                <div class="timeline">
                    <div
                        v-for="(activity, index) in activities"
                        :key="index"
                        class="timeline-item"
                    >
                        <div class="timeline-marker">
                            <i class="fa fa-bolt timeline-icon"></i>
                        </div>
                        <div class="timeline-content">
                            <div class="timeline-head">
                                <span class="timeline-title">{{ activity.title }}</span>
                                <span class="timeline-time">{{ activity.time }}</span>
                            </div>
                            <div class="timeline-message">{{ activity.message }}</div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "CrmNotesActivity",
    props: {
        accountId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            notes: [
                {
                    id: 1,
                    content: "Account is considering expanding to 50 seats by Q3. Follow up during the next review meeting.",
                    author: "SARAH J",
                    date: "FEB 05",
                },
            ],
            activities: [
                { title: "PLAN CHANGED", time: "1/1/26, 10:00 AM", message: "Upgraded to Enterprise Plan" },
                { title: "PAYMENT", time: "2/2/26, 2:30 PM", message: "Invoice #INV-2026-001 marked as Paid" },
                { title: "TICKET CREATED", time: "2/10/26, 9:15 AM", message: "New support ticket #SR1523 created" },
            ],
        };
    },
    methods: {
        addNote() {
            console.log("addNote");
        },
        deleteNote(note) {
            console.log("deleteNote", note);
        },
    },
};
</script>

<style scoped>
.crm-notes-activity {
    padding: 0;
}

.notes-activity-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

.notes-card,
.timeline-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 24px;
}

.notes-card >>> .card-body,
.timeline-card >>> .card-body {
    padding: 0;
}

.card-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.card-label {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    color: #6c757d;
}

.link-add {
    font-weight: 600;
    color: #1565c0;
    font-size: 0.9rem;
}

.link-add:hover {
    color: #0d47a1;
    text-decoration: underline;
}

.notes-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.note-item {
    background: #fffbea;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #f5f0d8;
}

.note-content {
    font-size: 0.95rem;
    color: #1a1d21;
    line-height: 1.5;
    margin-bottom: 12px;
}

.note-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.note-meta {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    color: #b8860b;
}

.btn-delete-note {
    color: #b8860b;
    font-size: 1rem;
}

.btn-delete-note:hover {
    color: #8b6914;
}

/* Timeline */
.timeline {
    position: relative;
    padding-left: 0;
}

.timeline-item {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
    position: relative;
}

.timeline-item:last-child {
    margin-bottom: 0;
}

.timeline-item:not(:last-child)::before {
    content: "";
    position: absolute;
    left: 15px;
    top: 36px;
    bottom: -24px;
    width: 2px;
    background: #e9ecef;
}

.timeline-marker {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e3f2fd;
    color: #1565c0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    z-index: 1;
}

.timeline-icon {
    font-size: 0.9rem;
}

.timeline-content {
    flex: 1;
    min-width: 0;
}

.timeline-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.timeline-title {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    color: #495057;
}

.timeline-time {
    font-size: 0.8rem;
    color: #6c757d;
}

.timeline-message {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 0.9rem;
    color: #1a1d21;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

@media (max-width: 992px) {
    .notes-activity-layout {
        grid-template-columns: 1fr;
    }
}
</style>
